<template>
 <div class="products-container">
    <el-card class="card">
      <div class="title">【产品管理】</div>
      <div class="center">
        <!-- 搜索栏 -->
        <div class="search-bar">
          <el-input v-model="searchQuery" placeholder="请输入产品名称" class="search-input"></el-input>
          <el-button type="primary" @click="searchProducts" class="search-button">搜索</el-button>
          <el-button type="success" @click="showAddProductDialog" class="search-button">新增产品</el-button>
        </div>

        <!-- 产品列表 -->
        <el-table :data="products" style="width: 100%" stripe class="product-table">
          <el-table-column prop="name" label="产品名称" sortable></el-table-column>
          <el-table-column prop="price" label="价格" sortable></el-table-column>
          <el-table-column label="产品图片">
            <template slot-scope="scope">
              <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.mainImage"
                fit="cover"
                @click="showImageDialog(scope.row.mainImage)"
                :preview-src-list="[scope.row.mainImage]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="产品详情">
            <template slot-scope="scope">
              <el-tooltip placement="top" popper-class="tooltip-width">
                <div slot="content" v-html="scope.row.description"></div>
                <el-link type="primary">详情</el-link>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="skuList" label="sku">
            <template slot-scope="scope">
              <el-tooltip placement="top" popper-class="tooltip-width">
                <div slot="content" v-html="scope.row.skuList"></div>
                <el-link type="primary">sku</el-link>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="规格">
            <template slot-scope="scope">
              <el-tooltip placement="top" popper-class="tooltip-width">
                <div slot="content" v-html="scope.row.specs"></div>
                <el-link type="primary">规格</el-link>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="editProduct(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="confirmDeleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @current-change="handlePageChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="totalProducts"
          class="pagination"
        >
        </el-pagination>
      </div>
    </el-card>
    <!-- 删除确认弹窗 -->
    <el-dialog title="确认删除" :visible.sync="deleteProductDialogVisible">
      <span>你确定要删除这个产品吗？</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteProductDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteProduct">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {deleteProductById, getProductsPaged, searchProductsByName} from '@/api/index.js';

export default {
  name: 'Products',
  data() {
    return {
      searchQuery: '',// 搜索框的值
      products: [],// 产品列表
      currentPage: 1,// 当前页
      pageSize: 10,// 每页显示的数量
      totalProducts: 0,// 总产品数
      deleteProductDialogVisible: false, // 删除产品弹窗是否显示
      productToDelete: null,// 要删除的产品
       currentImage: ''// 用于存储当前要查看的图片
    };
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await getProductsPaged(this.currentPage - 1, this.pageSize, 'id');
        if (response.code === 0) {
          this.products = response.data.products;
          this.totalProducts = response.data.total;
          // console.log('产品列表:', response.data.products);
        } else {
          this.$message.error('获取产品列表失败: ' + response.message);
          // console.log('产品列表失败:', response.message);
        }
      } catch (error) {
        this.$message.error('获取产品列表失败: ' + error.message);
      }
    },
    async searchProducts() {
      try {
        const response = await searchProductsByName(this.searchQuery);
        if (response.code === 0) {
          this.products = response.data;
          this.totalProducts = response.data.length;
          // console.log('搜索结果:', response.data);
        } else {
          this.$message.error('搜索失败: ' + response.message);
          // console.log('搜索失败:', response.message);
        }
      } catch (error) {
        this.$message.error('搜索失败: ' + error.message);
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchProducts();
    },
    showAddProductDialog() {
      // this.addProductDialogVisible = true;
      this.$router.push({name: "AddProduct" });
    },
    // 编辑产品：复用新增产品跳转页，携带产品ID进入编辑模式
    editProduct(product) {
      this.$router.push({name: "AddProduct", query: {id: product.id}});
    },
    // 确认删除产品
    confirmDeleteProduct(product) {
      this.productToDelete = product;
      this.deleteProductDialogVisible = true;
    },
    async deleteProduct() {
      if (!this.productToDelete) {
        this.$message.error('未选择要删除的产品');
        return;
      }
      try {
        // 实现删除产品的逻辑
        const response = await deleteProductById(this.productToDelete.id);
        if (response.code === 0) {
          this.$message.success('删除成功');
          this.fetchProducts(); // 重新获取产品列表
          this.deleteProductDialogVisible = false;
          this.productToDelete = null; // 重置 productToDelete
        } else {
          this.$message.error('删除失败: ' + response.message);
        }
      } catch (error) {
        this.$message.error('删除失败: ' + error.message);
      }
    },
    showImageDialog(imageUrl) {
      this.currentImage = imageUrl;
    }
  }
};
</script>

<style lang="scss">
.tooltip-width {
  max-width: 50%;
}
</style>

<style lang="scss" scoped>
.products-container {
  padding: 20px;
}

.card {
  min-height: 500px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.search-input {
  flex: 1;
  margin-right: 10px;
  margin-bottom: 10px;
}

.search-button {
  margin-right: 10px;
  margin-bottom: 10px;
}

.product-table {
  margin-bottom: 20px;
}

.pagination {
  text-align: center;
}

@media (max-width: 768px) {
  .products-container {
    padding: 10px;
  }

  .search-bar {
    flex-direction: column;
  }

  .search-input,
  .search-button {
    width: 100%;
    margin-right: 0;
  }

  .el-table {
    font-size: 12px;
  }

  .el-button--mini {
    padding: 5px 10px;
    font-size: 12px;
  }
}
</style>
